<div class="main">
  <div class="container-fluid">
    <!--<div id="commerces" class="card">
      <div class="card-header card-header-customer">
        <h4 class="card-title">
          {{ "DCO.ClaimsClient_DisputeConsultation" | translate }}
        </h4>
      </div>
      <br />-->
    <div id="commerces">
      <div class="box-title">
        <h5 class="fw-bold">
          {{ "DCO.ClaimsClient_DisputeConsultation" | translate }}
        </h5>
        <p class="text-muted">{{ "DCO.ClaimsClient_Dispute_PageDescription" | translate }}</p>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-12 px-4">
              <ul class="nav nav-tabs nav-line-tabs mb-3 fs-6">
                <li id="simplesearch"
                  class="nav-item">
                  <a class="nav-link fw-semibold active"
                    data-bs-toggle="tab"
                    href="#tab_pane_1">{{
                    "DCO.Search_SimpleSearch" | translate }}</a>
                </li>
                <li id="advancedsearch"
                  class="nav-item">
                  <a class="nav-link fw-semibold"
                    data-bs-toggle="tab"
                    href="#tab_pane_2">{{ "DCO.Search_AdvancedSearch"
                    |
                    translate }}</a>
                </li>
              </ul>
              <div class="tab-content"
                id="myTabContent">
                <div class="tab-pane fade show active py-2"
                  id="tab_pane_1"
                  role="tabpanel">
                  <form [formGroup]="formSearch">
                    <div class="input-group mb-3 me-3 w-25">
                      <input type="text"
                        class="form-control"
                        placeholder="Search"
                        formControlName="searchStandard"
                        name="searchStandard"
                        (keydown.enter)="SearchStandard($event)" />
                    </div>
                  </form>
                </div>
                <div class="tab-pane fade px-2 pb-3"
                  id="tab_pane_2"
                  role="tabpanel">
                  <!--<h5 class="">{{ "DCO.Search_FiltersTitle" | translate }}</h5>-->
                  <p class="text-sm text-primary mt-3 mb-4">
                    {{ "DCO.Search_FiltersDetails" | translate
                    }}<!--Utiliza parámetros para personalizar tu búsqueda con múltiples criterios.-->
                  </p>
                  <!-- Formulario de búsqueda -->
                  <form class="d-flex flex-wrap">
                    <div class="mb-3 me-3 flex-fill">
                      <label for="expediente"
                        class="fw-semibold form-label mb-1">{{
                        "DCO.OperationStatement_ExpedientNumber" | translate
                        }}</label>
                      <div class="input-group">
                        <select id="select_expediente"
                          class="form-select w-40">
                          <option value="igual"
                            selected>
                            {{ "DCO.ClaimsClient_Equal" | translate }}
                          </option>
                          <option value="diferente">
                            {{ "DCO.ClaimsClient_Different" | translate }}
                          </option>
                          <option value="empieza">
                            {{ "DCO.ClaimsClient_Starts" | translate }}
                          </option>
                          <option value="termina">
                            {{ "DCO.ClaimsClient_Ends" | translate }}
                          </option>
                          <option value="contiene">
                            {{ "DCO.ClaimsClient_Contains" | translate }}
                          </option>
                        </select>
                        <input type="text"
                          class="form-control w-60"
                          id="expediente"
                          [(ngModel)]="claimID"
                          [ngModelOptions]="{ standalone: true }"
                          (keydown.enter)="Search()" />
                      </div>
                    </div>
                    <div class="mb-3 me-3 flex-fill">
                      <label for="arn"
                        class="fw-semibold form-label mb-1">{{
                        "DCO.ClaimsClient_Arn" | translate
                        }}</label>
                      <div class="input-group">
                        <select id="select_arn"
                          class="form-select w-40">
                          <option value="igual"
                            selected>
                            {{ "DCO.ClaimsClient_Equal" | translate }}
                          </option>
                          <option value="diferente">
                            {{ "DCO.ClaimsClient_Different" | translate }}
                          </option>
                          <option value="empieza">
                            {{ "DCO.ClaimsClient_Starts" | translate }}
                          </option>
                          <option value="termina">
                            {{ "DCO.ClaimsClient_Ends" | translate }}
                          </option>
                          <option value="contiene">
                            {{ "DCO.ClaimsClient_Contains" | translate }}
                          </option>
                        </select>
                        <input type="text"
                          class="form-control w-60"
                          id="arn"
                          [(ngModel)]="arn"
                          [ngModelOptions]="{ standalone: true }"
                          (keydown.enter)="Search()" />
                      </div>
                    </div>
                    <div class="mb-3 me-3 flex-fill">
                      <label for="nComercio"
                        class="fw-semibold form-label mb-1">{{
                        "DCO.ClaimsClient_CommerceNumber" | translate
                        }}</label>
                      <div class="input-group">
                        <select id="select_nComercio"
                          class="form-select w-40">
                          <option value="igual"
                            selected>
                            {{ "DCO.ClaimsClient_Equal" | translate }}
                          </option>
                          <option value="diferente">
                            {{ "DCO.ClaimsClient_Different" | translate }}
                          </option>
                          <option value="empieza">
                            {{ "DCO.ClaimsClient_Starts" | translate }}
                          </option>
                          <option value="termina">
                            {{ "DCO.ClaimsClient_Ends" | translate }}
                          </option>
                          <option value="contiene">
                            {{ "DCO.ClaimsClient_Contains" | translate }}
                          </option>
                        </select>
                        <input type="text"
                          class="form-control w-60"
                          id="nComercio"
                          [(ngModel)]="commerceNumber"
                          [ngModelOptions]="{ standalone: true }"
                          (keydown.enter)="Search()" />
                      </div>
                    </div>
                    <div class="mb-3 me-3 flex-fill">
                      <label for="motivoDisputa"
                        class="fw-semibold form-label mb-1">{{
                        "DCO.OperationStatement_DisputeReason" | translate
                        }}</label>
                      <div class="input-group">
                        <!--        <select class="form-select w-25" id="select4">
                          <option value="igual" selected>{{"DCO.ClaimsClient_Equal" | translate}}</option>
                          <option value="diferente">{{"DCO.ClaimsClient_Different" | translate}}</option>
                          <option value="empieza">{{"DCO.ClaimsClient_Starts" | translate}}</option>
                          <option value="termina">{{"DCO.ClaimsClient_Ends" | translate}}</option>
                          <option value="contiene">{{"DCO.ClaimsClient_Contains" | translate}}</option>
                        </select>-->
                        <select class="form-select w-100"
                          id="motivoDisputa">
                          <option value=""
                            selected></option>
                          <option *ngFor="let reasons of reasons"
                            [value]="reasons">
                            {{ reasons | translate }}
                          </option>
                        </select>
                        <!--  <input type="text" class="form-control w-75" id="motivoDisputa" [(ngModel)]="subreasonName"
                          [ngModelOptions]="{ standalone: true }" (keydown.enter)="Search()" /> -->
                      </div>
                    </div>
                    <div class="mb-3 me-3 flex-fill">
                      <label for="actividadComercial"
                        class="fw-semibold form-label mb-1">{{
                        "DCO.ClaimsClient_CommercialActivity" | translate
                        }}</label>
                      <div class="input-group">
                        <select id="select_actividadComercial"
                          class="form-select w-40">
                          <option value="igual"
                            selected>
                            {{ "DCO.ClaimsClient_Equal" | translate }}
                          </option>
                          <option value="diferente">
                            {{ "DCO.ClaimsClient_Different" | translate }}
                          </option>
                          <!-- <option value="empieza">
                            {{ "DCO.ClaimsClient_Starts" | translate }}
                          </option>
                          <option value="termina">
                            {{ "DCO.ClaimsClient_Ends" | translate }}
                          </option>
                          <option value="contiene">
                            {{ "DCO.ClaimsClient_Contains" | translate }}
                          </option> -->
                        </select>
                        <input type="text"
                          class="form-control w-60"
                          id="actividadComercial"
                          [(ngModel)]="businessActivity"
                          [ngModelOptions]="{ standalone: true }"
                          (keydown.enter)="Search()" />
                      </div>
                    </div>
                    <div class="mb-3 me-3 flex-fill">
                      <label
                        for="fechaDisputa"
                        class="fw-semibold form-label mb-1">
                        {{ "DCO.OperationStatement_DisputeDate" | translate }}
                        (DD/MM/AAAA)
                      </label>

                      <div
                        [ngClass]="fechaDisputa.value === 'entre'
                          ? 'd-flex flex-nowrap gap-2'
                          : 'input-group'">

                        <select
                          id="select_fechaDisputa"
                          #fechaDisputa
                          class="form-select w-40">

                          <option value="igual" selected>
                            {{ "DCO.ClaimsClient_Equal" | translate }}
                          </option>

                          <option value="entre">
                            {{ "DCO.ClaimsClient_Between" | translate }}
                          </option>

                          <option value="menor">
                            {{ "DCO.ClaimsClient_Menor" | translate }}
                          </option>

                          <option value="mayor">
                            {{ "DCO.ClaimsClient_Mayor" | translate }}
                          </option>
                        </select>

                        <input
                          type="date"
                          class="form-control w-60"
                          id="fechaDisputa"
                          [(ngModel)]="operationDate"
                          [ngModelOptions]="{ standalone: true }" />

                        @if (fechaDisputa.value === 'entre') {
                          <label 
                            class="form-label mb-1 align-self-center">                            
                            {{ "AUT.Conditions_AND" | translate }}
                          </label>
                          <input
                            type="date"
                            class="form-control w-60"
                            id="fechaDisputaEnd"
                            [(ngModel)]="operationDateEnd"
                            [ngModelOptions]="{ standalone: true }" />
                        }
                      </div>
                    </div>
                    <div class="mb-3 me-3 flex-fill">
                      <label for="nombreComercio"
                        class="fw-semibold form-label mb-1">{{ "DCO.ClaimsClient_CommerceName"
                        |
                        translate }}</label>
                      <div class="input-group">
                        <select id="select_nombreComercio"
                          class="form-select w-40">
                          <option value="igual"
                            selected>
                            {{ "DCO.ClaimsClient_Equal" | translate }}
                          </option>
                          <option value="diferente">
                            {{ "DCO.ClaimsClient_Different" | translate }}
                          </option>
                          <option value="empieza">
                            {{ "DCO.ClaimsClient_Starts" | translate }}
                          </option>
                          <option value="termina">
                            {{ "DCO.ClaimsClient_Ends" | translate }}
                          </option>
                          <option value="contiene">
                            {{ "DCO.ClaimsClient_Contains" | translate }}
                          </option>
                        </select>
                        <input type="text"
                          class="form-control w-60"
                          id="nombreComercio"
                          [(ngModel)]="nombreComercio"
                          [ngModelOptions]="{ standalone: true }"
                          (keydown.enter)="Search()" />
                      </div>
                    </div>
                    <div class="mb-3 me-3 flex-fill">
                      <label for="marcaTarjeta"
                        class="fw-semibold form-label mb-1">{{ "DCO.ClaimsClient_CardBrand" |
                        translate }}</label>
                      <div class="input-group">
                        <select class="form-select"
                          id="marcaTarjeta">
                          <option value=""
                            selected></option>
                          <option value="0">VISA</option>
                          <option value="1">Master</option>
                          <option value="2">Amex</option>
                          <option value="3">Discovery</option>
                          <option value="4">Bizum</option>
                          <option value="5">On - Us</option>
                          <option value="6">ChinaUnionPay</option>
                        </select>
                      </div>
                    </div>
                    <div class="mb-3 me-3 flex-fill">
                      <label for="BIN"
                        class="fw-semibold form-label mb-1">{{
                        "DCO.ClaimsClient_BIN" | translate
                        }}</label>
                      <div class="input-group">
                        <select id="select_BIN"
                          class="form-select w-40">
                          <option value="igual"
                            selected>
                            {{ "DCO.ClaimsClient_Equal" | translate }}
                          </option>
                          <option value="diferente">
                            {{ "DCO.ClaimsClient_Different" | translate }}
                          </option>
                          <option value="empieza">
                            {{ "DCO.ClaimsClient_Starts" | translate }}
                          </option>
                          <option value="termina">
                            {{ "DCO.ClaimsClient_Ends" | translate }}
                          </option>
                          <option value="contiene">
                            {{ "DCO.ClaimsClient_Contains" | translate }}
                          </option>
                        </select>
                        <input type="text"
                          class="form-control w-60"
                          id="BIN"
                          [(ngModel)]="bin"
                          [ngModelOptions]="{ standalone: true }"
                          (keydown.enter)="Search()" />
                      </div>
                    </div>
                    <div class="mb-3 me-3">
                      <label
                        for="DateLastChangeStatus"
                        class="fw-semibold form-label mb-1">
                        {{ "DCO.ClaimsClient_DateLastChangeStatus" | translate }}
                        (DD/MM/AAAA)
                      </label>

                      <div
                        [ngClass]="dateLastChangeStatus.value === 'entre'
                          ? 'd-flex flex-nowrap gap-2'
                          : 'input-group'">

                        <select
                          id="select_DateLastChangeStatus"
                          #dateLastChangeStatus
                          class="form-select w-40"
                          style="max-width: 150px;">

                          <option value="igual" selected>
                            {{ "DCO.ClaimsClient_Equal" | translate }}
                          </option>

                          <option value="entre">
                            {{ "DCO.ClaimsClient_Between" | translate }}
                          </option>

                          <option value="menor">
                            {{ "DCO.ClaimsClient_Menor" | translate }}
                          </option>

                          <option value="mayor">
                            {{ "DCO.ClaimsClient_Mayor" | translate }}
                          </option>
                        </select>

                        <input
                          type="date"
                          class="form-control w-60"
                          style="max-width: 200px;"
                          id="DateLastChangeStatus"
                          [(ngModel)]="lastChangeDate"
                          [ngModelOptions]="{ standalone: true }" />

                        @if (dateLastChangeStatus.value === 'entre') {
                          <label 
                            class="form-label mb-1 align-self-center">                            
                            {{ "AUT.Conditions_AND" | translate }}
                          </label>
                          <input
                            type="date"
                            class="form-control w-60"
                            style="max-width: 200px;"
                            id="DateLastChangeStatusEnd"
                            [(ngModel)]="lastChangeDateEnd"
                            [ngModelOptions]="{ standalone: true }" />
                        }
                      </div>
                    </div>
                    <div class="mb-3 me-3">
                      <label for="Amount"
                        class="fw-semibold form-label mb-1">{{
                        "DCO.ClaimsClient_Amount" | translate
                        }}</label>
                      <div [ngClass]="AmountSelected.value === 'entre'
                          ? 'd-flex flex-nowrap gap-2'
                          : 'input-group'">
                        <select id="select_Amount"
                          #AmountSelected
                          class="form-select w-40">
                          <option value="igual"
                            selected>
                            {{ "DCO.ClaimsClient_Equal" | translate }}
                          </option>
                          <option value="diferente">
                            {{ "DCO.ClaimsClient_Different" | translate }}
                          </option>
                          <option value="entre">
                            {{ "DCO.ClaimsClient_Between" | translate }}
                          </option>
                          <option value="menor">
                            {{ "DCO.ClaimsClient_Menor" | translate }}
                          </option>
                          <option value="mayor">
                            {{ "DCO.ClaimsClient_Mayor" | translate }}
                          </option>
                        </select>
                        <input type="number"
                          class="form-control w-60"
                          id="amount"
                          [(ngModel)]="amount"
                          [ngModelOptions]="{ standalone: true }"
                          (keydown.enter)="Search()" />

                        @if (AmountSelected.value === 'entre') {
                          <label 
                            class="form-label mb-1 align-self-center">                            
                            {{ "AUT.Conditions_AND" | translate }}
                          </label>
                          <input
                            type="number"
                            class="form-control w-60"
                            style="max-width: 200px;"
                            id="amountEnd"
                            [(ngModel)]="amountEnd"
                            [ngModelOptions]="{ standalone: true }" />
                        }
                      </div>
                    </div>                    
                    <div class="my-3 me-3 ms-auto">
                      <button
                        class="btn btn-outline-primary fw-semibold text-sm mt-2"
                        id="buttonreset"
                        (click)="CleanSearch()"
                        type="button">
                        <i class="fa-solid fa-eraser"></i>
                        {{ "DCO.ClaimsClient_Clear" | translate }}
                      </button>

                      <button
                        class="btn btn-primary fw-semibold text-sm mt-2"
                        id="buttonsearch"
                        (click)="Search()">
                        <i class="fa-solid fa-magnifying-glass"></i>
                        {{ "DCO.ClaimsClient_Search" | translate }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Fin contenedor buscador -->
      <!-- Contenedor con prefiltros y tabla disputas -->
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-12 border-bottom">
              <!-- Botones PreFiltros-->
              <div class="d-flex flex-wrap">
                <div>
                  <!-- Indicador pendientes -->
                  <button id="button_pending"
                    class="btn text-nowrap"
                    [ngClass]="{
                  'btn-outline-danger': activeButton !== 'pending',
                  'btn-danger': (activeButton === 'pending' || activeButton === 'all' || activeButton === 'soon' || activeButton === 'today'|| activeButton === 'topfive')
                }"
                    (click)="setActiveButton('pending'); SearchClaimsPending()">
                    <i class="fa-solid fa-pause me-2"></i>
                    <label>{{
                      "DCO.SearchDisputeCommerce_Button1" | translate
                      }}</label>
                    <ng-container *ngFor="
                    let claimOperation of claimOperationStates;
                    let i = index
                  ">
                      <label id="dlabelhoy"
                        class="badge rounded-pill bg-danger border border-2 border-white ms-2"
                        *ngIf="claimOperation.stateGroup == 'Pendientes'">{{ claimOperation.countStates }}
                      </label>
                    </ng-container>
                  </button>
                </div>
                <div>
                  <!-- Indicador próximas a recibir -->
                  <button id="button_expected"
                    class="btn text-nowrap"
                    [ngClass]="{
                    'btn-outline-info': activeButton !== 'expected',
                    'btn-info': (activeButton === 'expected')
                    }"
                    (click)="setActiveButton('expected'); SearchClaimsExpected()">
                    <i class="fa-solid fa-pause me-2"></i>
                    <label>{{
                      "DCO.SearchDisputeCommerce_ButtonExpected" | translate
                      }}</label>
                    <ng-container *ngFor="
                    let claimOperation of claimOperationStates;
                    let i = index
                  ">
                      <label id="dlabelhoy"
                        class="badge rounded-pill bg-info border border-2 border-white ms-2"
                        *ngIf="claimOperation.stateGroup == 'Expected'">{{ claimOperation.countStates }}
                      </label>
                    </ng-container>
                  </button>
                </div>
                <div>
                  <!-- Indicador gestionados -->
                  <button id="button_finished"
                    class="btn text-nowrap"
                    [ngClass]="{
                  'btn-outline-primary': activeButton !== 'finished',
                  'btn-primary': activeButton === 'finished'
                  }"
                    (click)="setActiveButton('finished'); SearchClaimFinished()">
                    <i class="fa-solid fa-spinner me-2"></i>
                    <label>{{ "DCO.SearchDisputeCommerce_Button2" | translate }}
                    </label>
                    <ng-container *ngFor="
                    let claimOperation of claimOperationStates;
                    let i = index
                  ">
                      <label id="dlabelProx"
                        class="badge rounded-pill bg-primary border border-2 border-white ms-2"
                        *ngIf="claimOperation.stateGroup == 'Gestionados'">{{ claimOperation.countStates }}
                      </label>
                    </ng-container>
                  </button>
                </div>
                <div>
                  <!-- Indicador resueltas a favor -->
                  <button id="button_ok"
                    class="btn text-nowrap"
                    [ngClass]="{
                  'btn-outline-success': activeButton !== 'ok',
                  'btn-success': activeButton === 'ok'
                  }"
                    (click)="setActiveButton('ok'); SearchClaimsOk()">
                    <i class="fa-solid fa-thumbs-up me-2"></i>
                    <label>{{ "DCO.SearchDisputeCommerce_Button3" | translate }}
                    </label>
                    <ng-container *ngFor="
                    let claimOperation of claimOperationStates;
                    let i = index
                  ">
                      <label id="dlabelhoy"
                        class="badge rounded-pill bg-success border border-2 border-white ms-2"
                        *ngIf="claimOperation.stateGroup == 'Final_favorable'">{{ claimOperation.countStates }}</label>
                    </ng-container>
                  </button>
                </div>
                <div>
                  <!-- Indicador resueltas desfavorables -->
                  <button id="button_notOk"
                    class="btn text-nowrap"
                    [ngClass]="{
                  'btn-outline-warning': activeButton !== 'notOk',
                  'btn-warning': activeButton === 'notOk'
                  }"
                    (click)="SearchClaimNotOk(); setActiveButton('notOk')">
                    <i class="fa-solid fa-thumbs-down me-2"></i>
                    <label>{{ "DCO.SearchDisputeCommerce_Button4" | translate }}
                    </label>
                    <ng-container *ngFor="
                    let claimOperation of claimOperationStates;
                    let i = index
                  ">
                      <label id="dlabelhoy"
                        class="badge rounded-pill bg-warning border border-2 border-white ms-2"
                        *ngIf="claimOperation.stateGroup == 'Final_desfavorable'">{{ claimOperation.countStates
                        }}</label>
                    </ng-container>
                  </button>
                </div>
                <div>
                  <button class="btn btn-link text-nowrap"
                    id="buttonreset2"
                    (click)="CleanSearch()"
                    type="button">
                    <i class="fa-solid fa-eraser fa-lg me-3"></i>
                    {{ "DCO.ClaimsClient_Clear" | translate }}
                  </button>
                </div>
              </div>
              <!-- Indicador estado solo pendientes -->
              <div class="d-flex flex-wrap border-start border-danger border-2 ms-1 my-2"
                *ngIf="showBtnPendings">
                <div class="ps-3">
                  <!-- Indicador total -->
                  <button class="btn btn-sm m-0 mb-1 text-nowrap"
                    id="button_all"
                    [ngClass]="{
                  'btn-outline-light border-danger border-1': activeButton !== 'all',
                  'btn-outline-danger': activeButton === 'all'
                }"
                    (click)="setActiveButton('all'); SearchClaimsPending()">
                    <label class="text-danger text-sm">{{
                      "DCO.ClaimsClient_All" | translate
                      }}</label>
                    <label id="dlabelall"
                      class="badge rounded-pill bg-danger ms-2">
                      {{ total }}
                    </label>
                  </button>
                </div>
                <div class="ps-2">
                  <!-- Indicador próximas a vencimiento -->
                  <button class="btn btn-sm m-0 mb-1 text-nowrap"
                    id="button_soon"
                    [ngClass]="{
                  'btn-outline-light border-danger border-1': activeButton !== 'soon',
                  'btn-outline-danger': activeButton === 'soon'
                }"
                    (click)="setActiveButton('pending'); SearchClaimsSoon();">
                    <label class="text-danger text-sm">{{
                      "DCO.ClaimsClient_CloseToExpiration" | translate
                      }}</label>
                    <label id="dlabelProx"
                      class="badge rounded-pill bg-danger ms-2">
                      {{ countClaimsOperations?.CloseToExpire }}
                    </label>
                  </button>
                </div>
                <div class="ps-2">
                  <!-- Indicador vencen hoy-->
                  <button class="btn btn-sm m-0 mb-1 text-nowrap"
                    id="button_today"
                    [ngClass]="{
                  'btn-outline-light border-danger border-1': activeButton !== 'today',
                  'btn-outline-danger': activeButton === 'today'
                }"
                    (click)="setActiveButton('pending'); SearchClaimsToday()">
                    <label class="text-danger text-sm">{{
                      "DCO.ClaimsClient_ExpireToday" | translate
                      }}</label>
                    <label id="dlabelhoy"
                      class="badge rounded-pill bg-danger ms-2">
                      {{ countClaimsOperations?.ExpireToday }}</label>
                  </button>
                </div>
                <div class="ps-2">
                  <!-- Indicador Top 5 -->
                  <button class="btn btn-sm m-0 mb-1 text-nowrap"
                    id="button_topfive"
                    [ngClass]="{
                  'btn-outline-light border-danger border-1': activeButton !== 'topfive',
                  'btn-outline-danger': activeButton === 'topfive'
                }"
                    (click)="setActiveButton('topfive'); SearchClaimsTopFive()">
                    <label class="text-danger text-sm">{{
                      "DCO.ClaimsClient_TopFive" | translate
                      }}</label>
                    <label id="dlabeltopfive"
                      class="badge rounded-pill bg-danger ms-2">
                      {{this.topCount}}</label>
                  </button>
                </div>
              </div>
              <div id="div_pending"
                *ngIf="this.tabName === 'Pendientes'">
                <p id="p_pending"
                  class="text-sm text-muted mt-3">
                  <span class="fa-stack me-2 opacity-50">
                    <i class="fa-regular fa-circle text-primary fa-stack-2x"></i>
                    <i class="fa-solid fa-info text-primary fa-stack-1x"></i>
                  </span>
                  <span class="fst-italic">{{ "DCO.Search_FiltersHelpPending" | translate}}</span>
                </p>
              </div>
              <div id="div_expected"
                *ngIf="this.tabName === 'Expected'">
                <p id="p_expected"
                  class="text-sm text-muted mt-3">
                  <span class="fa-stack me-2 opacity-50">
                    <i class="fa-regular fa-circle text-primary fa-stack-2x"></i>
                    <i class="fa-solid fa-info text-primary fa-stack-1x"></i>
                  </span>
                  <span class="fst-italic">{{ "DCO.Search_FiltersHelpExpected" | translate}}</span>
                </p>
              </div>
              <div id="div_finished"
                *ngIf="this.tabName === 'Gestionados'">
                <p id="p_finished"
                  class="text-sm text-muted mt-3">
                  <span class="fa-stack me-2 opacity-50">
                    <i class="fa-regular fa-circle text-primary fa-stack-2x"></i>
                    <i class="fa-solid fa-info text-primary fa-stack-1x"></i>
                  </span>
                  <span class="fst-italic">{{ "DCO.Search_FiltersHelpFinished" | translate}}</span>
                </p>
              </div>
              <div id="div_ok"
                *ngIf="this.tabName === 'Final_favorable'">
                <p id="p_ok"
                  class="text-sm text-muted mt-3">
                  <span class="fa-stack me-2 opacity-50">
                    <i class="fa-regular fa-circle text-primary fa-stack-2x"></i>
                    <i class="fa-solid fa-info text-primary fa-stack-1x"></i>
                  </span>
                  <span class="fst-italic">{{ "DCO.Search_FiltersHelpOk" | translate}}</span>
                </p>
              </div>
              <div id="div_notok"
                *ngIf="this.tabName === 'Final_desfavorable'">
                <p id="p_notok"
                  class="text-sm text-muted mt-3">
                  <span class="fa-stack me-2 opacity-50">
                    <i class="fa-regular fa-circle text-primary fa-stack-2x"></i>
                    <i class="fa-solid fa-info text-primary fa-stack-1x"></i>
                  </span>
                  <span class="fst-italic">{{ "DCO.Search_FiltersHelpNotOk" | translate}}</span>
                </p>
              </div>
            </div>
            <!-- Tabla disputas -->
            <div class="col-12">
              <!-- Botón información masiva -->
              <div class="clearfix">
                <div class="float-end py-2">
                  <a [routerLink]="codemassive"
                    (click)="EncryptionMassive()"
                    class="btn btn-outline-primary text-sm fw-semibold"
                    *ngIf="massiveInfoButton"><i id="iconfolder"
                      class="fa-regular fa-folder-closed me-2"></i>{{
                    "DCO.MassiveInformation_Title" | translate }}</a>
                  <button id="button_download"
                    class="btn btn-primary text-sm fw-semibold"
                    (click)="DownloadClaims()">
                    <i class="fa-solid fa-download fa-lg me-2"></i>
                    <label>{{
                      "DCO.MassiveInformation_Download" | translate
                      }}</label>
                  </button>
                </div>
                <div class="float-end py-2">
                  <button id="button_download"
                    class="btn btn-outline-primary text-sm fw-semibold"
                    (click)="ShowDisputeColumnConfiguration()">
                    <i class="fa-solid fa-edit fa-lg me-2"></i>
                    <label>{{
                      "DCO.Dispute_TableColumnEdit" | translate
                      }}</label>
                  </button>
                </div>
              </div>
              <!-- Load -->
              <div *ngIf="!loadCompleted"
                class="d-flex justify-content-center"
                style="position: absolute; z-index:15">
                <div class="spinner-border spinner-border-smtext-customer"></div>
              </div>
              <!-- dynamic column table.start -->
              <div class="row">
                <div id="table_disputes"
                  class="table-responsive mx-0 px-0">
                  <table class="table table-hover order-table"
                    data-pagination="true"
                    data-page-size="10"
                    data-sortable="true">
                    <thead>
                      <tr>
                        <!-- <th class="text-center">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              [checked]="isAllSelected"
                              (change)="CheckAll($event)"
                            />
                          </th> -->
                        <th class="text-center">
                          {{ "DCO.ClaimsClient_Action" | translate }}
                        </th>
                        @for(column of displayColumns; track column.id){
                        <th class="text-center"  (click)="column.sortable && sortBy(column.id)" [class.pointer]="column.sortable">
                          {{ column.name| translate }}
                              @if(sortColumn === column.id){
                            <span>
                              {{ sortDirection === 'asc' ? '▲' : '▼' }}
                            </span>
                          }
                        </th>
                        }
                      </tr>
                    </thead>
                    <tbody>
                      <ng-template #empty>
                        <td colspan="5"
                          class="text-muted text-sm"
                          *ngIf="loadCompleted">
                          {{ "DCO.ClaimsClient_NoRecords" | translate }}
                        </td>
                      </ng-template>
                      <ng-container *ngIf="loadCompleted && claimOperations.length > 0; else empty">
                        <tr class="text-muted text-sm"
                          *ngFor="
                            let dispute of claimOperations
                              | paginate : { itemsPerPage: 10, currentPage: page };
                            index as i
                          ">
                          <td class="text-center">
                            <ng-container *ngIf="dispute.groupStateName == 'Pendientes'">
                              <!-- Indicador pendientes -->
                              <span id="editbutton"
                                class="align-center">
                                <a [routerLink]="code"
                                  class="btn btn-link"
                                  (click)="NavigateDetails(dispute.claimID,dispute.claimOperationID)"><i
                                    class="fa-regular fa-pen-to-square fa-lg text-primary"
                                    title="{{'DCO.ClaimsClient_Edit' | translate}}"></i></a></span>
                            </ng-container>
                            <ng-container *ngIf="dispute.groupStateName == 'Gestionados'">
                              <!-- Indicador gestionados -->
                              <span id="visualizeButton"
                                class="align-center">
                                <a [routerLink]="code"
                                  class="btn btn-link"
                                  (click)="NavigateDetails(dispute.claimID,dispute.claimOperationID)"><i
                                    class="fa-regular fa-eye fa-lg text-primary"
                                    title="{{'DCO.ClaimsClient_View' | translate}}"></i></a>
                              </span>
                            </ng-container>
                            <ng-container *ngIf="dispute.groupStateName == 'Expected'">
                              <!-- Indicador próximas -->
                              <span id="visualizeButton"
                                class="align-center">
                                <a [routerLink]="code"
                                  class="btn btn-link"
                                  (click)="NavigateDetails(dispute.claimID,dispute.claimOperationID)"><i
                                    class="fa-regular fa-eye fa-lg text-primary"
                                    title="{{'DCO.ClaimsClient_View' | translate}}"></i></a>
                              </span>
                            </ng-container>
                            <ng-container *ngIf="dispute.groupStateName == 'Final_favorable'">
                              <!-- Indicador resueltos a favor -->
                              <span id="visualizeButton"
                                class="align-center">
                                <a [routerLink]="code"
                                  class="btn btn-link"
                                  (click)="NavigateDetails(dispute.claimID,dispute.claimOperationID)"><i
                                    class="fa-regular fa-eye fa-lg text-primary"></i></a>
                              </span>
                            </ng-container>
                            <ng-container *ngIf="dispute.groupStateName == 'Final_desfavorable'">
                              <!-- Indicador resueltos desfavorables -->
                              <span id="visualizeButton"
                                class="align-center">
                                <a [routerLink]="code"
                                  class="btn btn-link"
                                  (click)="NavigateDetails(dispute.claimID,dispute.claimOperationID)"><i
                                    class="fa-regular fa-eye fa-lg text-primary"></i></a>
                              </span>
                            </ng-container>
                          </td>
                          @for(column of displayColumns; track column.id){
                          <td class="text-center"
                            id="massivetransfer">
                            @switch (column.id) {
                            @case ('claimOperationID'){
                            <span class="fw-semibold">{{ dispute.claimOperationID }}</span>
                            }
                            @case ('doc') {
                            {{ dispute.doc | date : currentFormats?.date }}
                            }
                            @case ('commerceNumber') {
                            {{ dispute.commerceNumber }}
                            }
                            @case ('commerceName') {
                            {{ dispute.commerceName }}
                            }
                            @case ('groupStateName') {
                            <ng-container *ngIf="dispute.groupStateName == 'Pendientes'">
                              <!-- Indicador pendientes -->
                              <label
                                class="alert alert-danger border-danger rounded-pill py-0 px-3 shadow-none text-sm m-0 text-nowrap">{{
                                "DCO.DisputeStatus_Pendientes" | translate }}</label>
                            </ng-container>
                            <ng-container *ngIf="dispute.groupStateName == 'Expected'">
                              <!-- Indicador Próximas a recibir -->
                              <label
                                class="alert alert-info border-info rounded-pill py-0 px-3 shadow-none text-sm m-0 text-nowrap">{{
                                "DCO.DisputeStatus_Expected" | translate }}</label>
                            </ng-container>
                            <ng-container *ngIf="dispute.groupStateName == 'Gestionados'">
                              <!-- Indicador gestionados -->
                              <label
                                class="alert alert-primary border-primary rounded-pill py-0 px-3 shadow-none text-sm m-0 text-nowrap">{{
                                "DCO.DisputeStatus_Gestionados" | translate }}
                              </label>
                            </ng-container>
                            <ng-container *ngIf="dispute.groupStateName == 'Final_favorable'">
                              <!-- Indicador resueltos a favor -->
                              <label
                                class="alert alert-success border-success rounded-pill py-0 px-3 shadow-none text-sm m-0 text-nowrap">{{
                                "DCO.DisputeStatus_Final_favorable" | translate }}
                              </label>
                            </ng-container>
                            <ng-container *ngIf="dispute.groupStateName == 'Final_desfavorable'">
                              <!-- Indicador resueltos desfavorables -->
                              <label
                                class="alert alert-warning border-warning rounded-pill py-0 px-3 shadow-none text-sm m-0 text-nowrap">{{
                                "DCO.DisputeStatus_Final_desfavorable" | translate }}
                              </label>
                            </ng-container>
                            }
                            @case ('subReasonName') {
                                @if (dispute.clientReason) {
                                    {{ dispute.clientReason }}
                                } @else {
                                    {{ dispute.subReasonName | translate }}
                                }
                            }
                            @case ('CardBrand') {
                            {{ "@@DCO.paymentscheme_" + dispute.paymentScheme | translate }}  {{ "@@DCO.compensation_" + dispute.compensation | translate }}
                            }
                            @case ('card') {
                            {{ dispute.card }}
                            }
                            @case ('amount') {
                            {{ dispute.amount | currency:'' : '' : currentFormats?.currency?.digits :
                            currentFormats?.currency?.locale }}
                            {{ getCurrencyCode(dispute.currency) }}
                            }
                            @case ('dateLimit') {
                            <ng-container *ngIf="tabName === 'Pendientes' || tabName === 'Expected'">
                              <ng-container *ngIf="!dispute.dateLimit">
                                {{ (dispute?.expirationDate && dispute.expirationDate !== 'undefined' &&
                                dispute.expirationDate !== '')
                                ? (dispute.expirationDate | date : currentFormats?.date)
                                : '' }}
                              </ng-container>
                              <ng-container *ngIf="dispute.dateLimit">
                                {{ (dispute?.dateLimit && dispute.dateLimit !== 'undefined' && dispute.dateLimit !== '')
                                ? (dispute.dateLimit | date : currentFormats?.date)
                                : '' }}
                              </ng-container>
                            </ng-container>
                            }
                            @case ('lastStatusChange') {
                            {{ dispute.lastStatusChange | date : currentFormats?.date }}
                            }
                            @case ('claimOperation_Authorization') {
                            {{ dispute.claimOperation_Authorization }}
                            }
                            @case ('arn') {
                            {{ dispute.arn }}
                            }
                            @case ('operations_P37') {
                            {{ dispute.operations_P37 }}
                            }
                            @case ('operations_P48') {
                            {{ dispute.operations_P48 }}
                            }
                            }
                          </td>
                          }
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                  <div class="text-center">
                    <pagination-controls (pageChange)="page = $event"></pagination-controls>
                  </div>
                </div>
              </div>
              <!-- dynamic column table.end -->
            </div>
          </div>
        </div>
      </div>
      <!-- Fin contenedor prefiltros y tabla disputas -->
    </div>
  </div>
</div>
<div class="modal fade"
  id="modalColumnsSelection"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable">
    <div class="modal-content">
      <!-- HEADER con X -->
      <div class="modal-header">
        <h6 class="modal-title mb-0">
          {{ "DCO.Disputes_TableConfiguration" | translate }}
        </h6>
        <!-- Botón de X para cerrar el modal -->
        <button type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close">
        </button>
      </div>
      <!-- BODY -->
      <div class="modal-body">
        <div class="modal-body">
          <DCO-table-configuration [availableColumns]="availableColumns"
            [selectedColumns]="selectedColumns"></DCO-table-configuration>
        </div>
        <div class="d-flex  justify-content-end">
          <div>
            <button class="btn btn-outline-primary" data-bs-dismiss="modal">
              {{"DCO.Disputes_Cancel" | translate}}
            </button>
          </div>
          <div>
            <button type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              (click)="SaveDisputeColumnConfiguration()">
              {{"DCO.Disputes_Save" | translate}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>